export const StationMarkerIcon = () => {
  return (
    <svg
      width="51"
      height="54"
      viewBox="0 0 51 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_14398_102424)">
        <mask
          id="mask0_14398_102424"
          maskUnits="userSpaceOnUse"
          x="5"
          y="5"
          width="41"
          height="40"
        >
          <rect x="5.5" y="5" width="40" height="40" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_14398_102424)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30.0976 37.6386C36.778 35.659 41.6516 29.4746 41.6516 22.152C41.6516 13.2326 34.421 6.00195 25.5016 6.00195C16.5822 6.00195 9.35156 13.2326 9.35156 22.152C9.35156 29.4747 14.2252 35.6592 20.9058 37.6387L25.5017 42.4172L30.0976 37.6386Z"
            fill="#009EFA"
          />
          <circle cx="25.4992" cy="22.1516" r="13.3" fill="white" />
          <mask
            id="mask1_14398_102424"
            maskUnits="userSpaceOnUse"
            x="16"
            y="12"
            width="19"
            height="20"
          >
            <rect x="16" y="12.6514" width="19" height="19" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask1_14398_102424)">
            <path
              d="M24.5827 14.5518L18.9098 22.1285H23.1033L18.8516 29.7518L28.3686 20.2576H24.5478L28.7413 14.5518H24.5827Z"
              fill="#009EFA"
            />
            <path
              d="M29.2746 17.5947L31.4299 14.5518H29.2292L26.9922 17.5897L29.2746 17.5947Z"
              fill="#009EFA"
            />
            <path
              d="M31.188 17.5947L33.2651 14.5518H31.9045L29.7461 17.5897L31.188 17.5947Z"
              fill="#009EFA"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_dd_14398_102424"
          x="-3.05"
          y="-0.9375"
          width="57.1"
          height="57.1"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.6125" />
          <feGaussianBlur stdDeviation="4.275" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_14398_102424"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.2375" />
          <feGaussianBlur stdDeviation="1.425" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.039 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_14398_102424"
            result="effect2_dropShadow_14398_102424"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_14398_102424"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
